/* cfam-tip — tooltip TUC THI ten mau tren o mau (hang Colour o trang san pham + o mau tren the trang chu). Chu shop 14/10/2026.
   Truoc: ten mau chi hien qua thuoc tinh title -> trinh duyet tre ~1 giay. Nay moi o co data-tip="<ten mau>" (cung chuoi cu cua title,
   title da bo de khong hien 2 tooltip chong nhau; aria-label giu nguyen).
   Vi sao co JS: hang o mau o ca hai noi deu CAT noi dung tran ra ngoai (trang SP: overflow-x:auto -> y cung bi cat; the trang chu:
   .cfam__hang overflow:hidden), nen ::after tren o se bi cat mat. Mot phan tu duy nhat position:fixed gan vao <body> thi khong bao gio
   bi cat, tu keo vao trong khung nhin, va khong dung setTimeout/delay nao: hien dung luc con tro vao o.
   Chi chuot (hover: hover). Man cham: khong hien (cham la di link/doi mau luon). */
(function () {
  if (window.__cfamTip) return;
  window.__cfamTip = 1;

  var CSS =
    '.cfam-tip{position:fixed;left:0;top:0;z-index:10000;padding:4px 8px;border-radius:4px;background:#111;color:#fff;' +
    'font-size:var(--cfam-tip-chu,11px);font-weight:400;font-style:normal;letter-spacing:0;text-transform:none;text-align:center;' +
    'line-height:1.3;white-space:nowrap;pointer-events:none;--cfam-tip-chu:11px}' +
    '.cfam-tip[hidden]{display:none}' +
    '.cfam-tip::before{content:"";position:absolute;left:var(--cfam-tip-ax,50%);margin-left:-4px;width:0;height:0;border:4px solid transparent}' +
    '.cfam-tip[data-pos="top"]::before{top:100%;border-top-color:#111}' +
    '.cfam-tip[data-pos="bottom"]::before{bottom:100%;border-bottom-color:#111}' +
    '@media screen and (min-width:750px){.cfam-tip{--cfam-tip-chu:12px}}';

  var tip = null, cur = null;

  function dung() {
    if (tip) return tip;
    var st = document.createElement('style');
    st.setAttribute('data-cfam-tip', '');
    st.textContent = CSS;
    document.head.appendChild(st);
    tip = document.createElement('div');
    tip.className = 'cfam-tip';
    tip.setAttribute('aria-hidden', 'true');
    tip.hidden = true;
    document.body.appendChild(tip);
    return tip;
  }

  function an() {
    cur = null;
    if (tip) tip.hidden = true;
  }

  function hien(t) {
    if (window.matchMedia && matchMedia('(hover: none)').matches) return;   /* man cham: khong hien */
    var chu = t.getAttribute('data-tip');
    if (!chu) return an();
    var el = dung();
    cur = t;
    el.textContent = chu;
    el.hidden = false;
    var r = t.getBoundingClientRect();
    var w = el.offsetWidth, h = el.offsetHeight;
    var vw = document.documentElement.clientWidth, M = 4, KHE = 8;
    var x = Math.round(r.left + r.width / 2 - w / 2);
    x = Math.max(M, Math.min(x, vw - w - M));
    var tren = r.top - h - KHE >= M;
    el.setAttribute('data-pos', tren ? 'top' : 'bottom');
    el.style.setProperty('--cfam-tip-ax', Math.round(r.left + r.width / 2 - x) + 'px');
    el.style.left = x + 'px';
    el.style.top = Math.round(tren ? r.top - h - KHE : r.bottom + KHE) + 'px';
  }

  function goc(e) {
    return e.target && e.target.closest ? e.target.closest('[data-tip]') : null;
  }

  document.addEventListener('pointerover', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
    var t = goc(e);
    if (!t) { if (cur) an(); return; }
    if (t !== cur) hien(t);
  });
  document.addEventListener('pointerout', function (e) { if (!e.relatedTarget) an(); });
  document.addEventListener('focusin', function (e) {
    var t = goc(e);
    if (t && t.matches && t.matches(':focus-visible')) hien(t);
  });
  document.addEventListener('focusout', function () { an(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') an(); });
  document.addEventListener('scroll', function () { if (cur) an(); }, true);
  addEventListener('resize', function () { if (cur) an(); });
})();
